import React, { useCallback } from 'react'

//components
import { FormControl, InputLabel, MenuItem } from '@mui/material'
import Select from '@mui/material/Select'

//translations and messages
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { changeLanguage, setLanguageRequest } from '../../App/module/actions'
import { selectLanguage } from '../../App/module/selectors'
import messages from './module/messages'
import itImg from './../../assets/images/it.png'
import enImg from './../../assets/images/en.png'

import classes from './LanguageSelect.module.scss'

interface ILanguageSelectProps {
  colorPrimary?: boolean
  changeLanguage: (lang: string) => {}
  setLanguageRequest: (lang: string) => void
  lang: string
}

const imgAssetsFlags = {
  it: itImg,
  en: enImg,
}

const langChangeValue = {
  it: 'ITA',
  en: 'ENG',
}

const LanguageSelect = (props: ILanguageSelectProps) => {
  const { lang, colorPrimary, changeLanguage, setLanguageRequest } = props

  const handleChange = useCallback((e: any) => {
    const { target } = e
    changeLanguage(target.value)
    setLanguageRequest(
      langChangeValue[target.value as keyof typeof langChangeValue]
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FormControl variant="filled" sx={{ height: '6vh' }} fullWidth>
      <InputLabel
        className={`${classes['select-ui-filled-field-label']} ${
          colorPrimary ? classes.primaryColor : ''
        }`}
        id={`select-languge-label`}
        variant="filled"
        sx={{ color: 'white' }}
      >
        <FormattedMessage {...messages.label} />
      </InputLabel>
      <div className={classes.space}>
        <Select
          className={`${classes['select-ui-filled-field']} ${
            colorPrimary ? classes.primaryColor : ''
          }`}
          labelId={`select-languge-label`}
          id={`select-languge-id`}
          label={<FormattedMessage {...messages.label} />}
          value={lang || ''}
          renderValue={(value: string | number | any) => (
            <React.Fragment>
              <FormattedMessage {...messages[value as keyof typeof messages]} />
              <img
                src={imgAssetsFlags[value as keyof typeof imgAssetsFlags]}
                className={classes.img}
                alt={value}
              />
            </React.Fragment>
          )}
          onChange={(e: any) => handleChange(e)}
          sx={{
            backgroundColor: '#2d32aa',
            border: 'none',
            color: 'white',
            width: '100%',
          }}
        >
          <MenuItem value={'it'}>
            <div className={classes['menu-items']}>
              <FormattedMessage {...messages.it} />
              <img src={itImg} className={classes.img} alt="it" />
            </div>
          </MenuItem>
          <MenuItem value={'en'}>
            <div className={classes['menu-items']}>
              <FormattedMessage {...messages.en} />
              <img src={enImg} className={classes.img} alt="en" />
            </div>
          </MenuItem>
        </Select>
      </div>
    </FormControl>
  )
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    lang: selectLanguage,
  })

const mapDispatchToProps: any = {
  changeLanguage: (lang: string) => changeLanguage(lang),
  setLanguageRequest,
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(LanguageSelect)
